import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, StarIcon, UsersIcon, BookOpenIcon, MapPinIcon, FileTextIcon, ZapIcon, UsersRoundIcon } from 'lucide-react';
import { CTAButton, Section } from './Shared';
export function Hero() {
  return <Section bg="cream" className="pt-8 md:pt-24 pb-8 md:pb-16" data-id="element-96">
      {/* Centered single-column layout */}
      <div className="flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-97">
        {/* Top badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-block bg-charcoal text-white font-bold px-4 py-1.5 rounded-full text-[10px] md:text-sm uppercase tracking-wider mb-3 md:mb-6" data-id="element-98">
          GAP 360 MEGAPACK — SISTEMA COMPLETO
        </motion.div>

        {/* Main heading */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-charcoal mb-3 md:mb-8" data-id="element-99">
          Todo tu año de{' '}
          <span className="italic text-coral" data-id="element-100">GAP resuelto.</span>
          <br data-id="element-101" />
        </motion.h1>

        {/* Product mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-[55%] md:w-[70%] mx-auto mb-4 md:mb-8" data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/bi7ra5mWQ9uL2WGqJEkG5o/heylloyd-image-1775864005324-Photoroom.png" alt="GAP 360 Megapack - Sistema completo de Glúteos, Abdomen y Piernas" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-103" />
        </motion.div>

        {/* Stats subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-base md:text-xl font-bold italic text-rosegold mb-2 md:mb-4" data-id="element-104">
          6 Tomos · 100+ Ejercicios · 6 Bonos · Listo para usar.
        </motion.p>

        {/* Description */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="text-sm md:text-lg text-gray-600 mb-3 md:mb-6 max-w-md" data-id="element-105">
          Tu año completo de clases GAP listo: ejercicios, técnica, progresión,
          accesorios, poblaciones especiales y negocio. Sin improvisar.
        </motion.p>

        {/* Feature badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-8" data-id="element-106">
          <span className="inline-flex items-center gap-1 bg-white border border-gray-200 px-3 py-1.5 rounded-full text-xs md:text-sm font-semibold text-gray-600 shadow-sm" data-id="element-107">
            <FileTextIcon size={14} className="text-rosegold" data-id="element-108" />
            PDF digital
          </span>
          <span className="inline-flex items-center gap-1 bg-white border border-gray-200 px-3 py-1.5 rounded-full text-xs md:text-sm font-semibold text-gray-600 shadow-sm" data-id="element-109">
            <ZapIcon size={14} className="text-coral" data-id="element-110" />
            Acceso inmediato
          </span>
          <span className="inline-flex items-center gap-1 bg-white border border-gray-200 px-3 py-1.5 rounded-full text-xs md:text-sm font-semibold text-gray-600 shadow-sm" data-id="element-111">
            <UsersRoundIcon size={14} className="text-rosegold" data-id="element-112" />
            Todos los niveles
          </span>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.45
      }} className="w-full max-w-md mb-3 md:mb-6" data-id="element-113">
          <CTAButton fullWidth className="text-base md:text-xl py-4 md:py-5" data-id="element-114">
            💥 → QUIERO MI GAP 360 AHORA
          </CTAButton>
        </motion.div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-wrap items-center justify-center gap-3 text-xs md:text-sm font-semibold text-gray-500 mb-1" data-id="element-115">
          <div className="flex items-center gap-1" data-id="element-116">
            <ShieldCheckIcon size={16} className="text-green-500" data-id="element-117" />
            Garantía 7 días
          </div>
          <div className="flex items-center gap-1" data-id="element-118">
            <LockIcon size={16} className="text-green-500" data-id="element-119" />
            Pago 100% seguro
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.55
      }} className="flex items-center gap-1 text-sm text-gray-400" data-id="element-120">
          <CreditCardIcon size={14} data-id="element-121" />
          Mercado Pago | Tarjeta
        </motion.div>
      </div>

      {/* Stats bar */}
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.6
    }} className="mt-6 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 bg-white p-4 md:p-8 rounded-xl md:rounded-2xl shadow-xl border border-gray-100" data-id="element-122">
        <div className="flex flex-col items-center text-center space-y-1 md:space-y-2" data-id="element-123">
          <UsersIcon className="text-coral" size={24} data-id="element-124" />
          <span className="font-bold text-sm md:text-lg text-charcoal" data-id="element-125">
            +500 INSTRUCTORAS
          </span>
          <span className="text-xs md:text-sm text-gray-500" data-id="element-126">CONFÍAN</span>
        </div>
        <div className="flex flex-col items-center text-center space-y-1 md:space-y-2" data-id="element-127">
          <BookOpenIcon className="text-rosegold" size={24} data-id="element-128" />
          <span className="font-bold text-sm md:text-lg text-charcoal" data-id="element-129">
            6+6 TOMOS
          </span>
          <span className="text-xs md:text-sm text-gray-500" data-id="element-130">+ BONOS</span>
        </div>
        <div className="flex flex-col items-center text-center space-y-1 md:space-y-2" data-id="element-131">
          <div className="flex text-gold" data-id="element-132">
            <StarIcon fill="currentColor" size={24} data-id="element-133" />
          </div>
          <span className="font-bold text-sm md:text-lg text-charcoal" data-id="element-134">
            4.9/5 CALIFICACIÓN
          </span>
          <span className="text-xs md:text-sm text-gray-500" data-id="element-135">EXCELENTE</span>
        </div>
        <div className="flex flex-col items-center text-center space-y-1 md:space-y-2" data-id="element-136">
          <MapPinIcon className="text-blue-400" size={24} data-id="element-137" />
          <span className="font-bold text-sm md:text-lg text-charcoal" data-id="element-138">
            🇦🇷 TODO EL PAÍS
          </span>
          <span className="text-xs md:text-sm text-gray-500" data-id="element-139">ARGENTINA</span>
        </div>
      </motion.div>
    </Section>;
}